import { render, staticRenderFns } from "./ShowCarousel.vue?vue&type=template&id=57178510&scoped=true&"
import script from "./ShowCarousel.vue?vue&type=script&lang=js&"
export * from "./ShowCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ShowCarousel.vue?vue&type=style&index=0&id=57178510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57178510",
  null
  
)

export default component.exports